import { render, staticRenderFns } from "./referans.vue?vue&type=template&id=2e10daae&"
import script from "./referans.vue?vue&type=script&lang=js&"
export * from "./referans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports